import Model from "./model";
import ApiDashPattern from "../api/model/snapshots/layers/DashPattern";

export default class DashPattern extends Model {
    dash: number;
    gap: number;

    constructor({
        dash,
        gap
    }: ApiDashPattern) {
        super();
        this.dash = dash;
        this.gap = gap;
    }

    override toObject() {
        return {
            dash: this.dash,
            gap: this.gap
        };
    }
}
